import type { IUser } from '~/interfaces/user/IUser';

interface IUserStore {
  user: IUser|null
  currentGender: string
}

export const useUserStore = defineStore({
  id: 'user',
  state: (): IUserStore => ({
    user: null,
    currentGender: 'hommes'
  }),
  getters: {
  },
  actions: {
  },
});

export {
}
